const Joi = require('joi');
const passwordComplexity = require("joi-password-complexity").default;
const complexityOptions = {
    min: 8,
    max: 250,
    lowerCase: 1,
    upperCase: 1,
    numeric: 1,
    symbol: 1,
    requirementCount: 2,
};
const loginSchema = Joi.object({
    name: Joi.string()
            .min(3)
            .max(40)
            .required(),
    password: Joi.string()
            .min(1)
            .required()
});

const emailSchema = Joi.object({
    email: Joi.string()
            .email({ minDomainSegments: 2, tlds: false })
});

const verificationSchema = Joi.object({
    code: Joi.string().min(6),
    password: passwordComplexity(complexityOptions)
});

const createUserSchema = Joi.object({
    firstName: Joi.string().min(3).max(25).required(),
    middleName: Joi.string().min(3).max(25).required(),
    lastName: Joi.string().min(3).max(25).required(),
    email: Joi.string().email({ minDomainSegments: 2, tlds: false }).required(),
    alias: Joi.string().min(3).max(25).required(),
    username: Joi.string().min(3).max(25).required(),
})

const changePasswordSchema = Joi.object({
    password: passwordComplexity(complexityOptions)
})

function validateInputFields(inputObj){
  var validateResponse = {};
  var count = 0;
  Object.keys(inputObj).forEach(key =>{    
    if(inputObj[key] != null && inputObj[key] != ""){
      if(typeof inputObj[key].isRequired != 'undefined'){
        if(inputObj[key].isRequired && inputObj[key].value){
          if(typeof inputObj[key].isNumeric != 'undefined' && inputObj[key].isNumeric){
            if(typeof inputObj[key].min != 'undefined' || typeof inputObj[key].max != 'undefined'){
              if(inputObj[key].value.toString().length >= inputObj[key].min && inputObj[key].value.toString().length <= inputObj[key].max){
                var res = validate(inputObj[key].value, key);
                if(res != "valid"){
                  validateResponse[key] = res;
                  count++;
                }
              }else{
                validateResponse[key] = getErrorMessage(key);
                count++;
              } 
            }else{
              var res = validate(inputObj[key].value, key);
              if(res != "valid"){
                validateResponse[key] = res;
                count++;
              }
            }     
          }
        }else{
          validateResponse[key] = "Required Field";
          count++;
        }
      }
      else{
        if(typeof inputObj[key].isNumeric != 'undefined' && inputObj[key].isNumeric){
          if(typeof inputObj[key].min != 'undefined' || typeof inputObj[key].max != 'undefined'){
            if(inputObj[key].value.toString().length >= inputObj[key].min && inputObj[key].value.toString().length <= inputObj[key].max){
              var res = validate(inputObj[key].value, key);
              if(res != "valid"){
                validateResponse[key] = res;
                count++;
              }
            }else{
              validateResponse[key] = getErrorMessage(key);
              count++;
            } 
          }else{
            var res = validate(inputObj[key].value, key);
            if(res != "valid"){
              validateResponse[key] = res;
              count++;
            }
          }     
        }
      }
    }    
  });

  if(count > 0){
    validateResponse['error'] = true;
    validateResponse['error_count'] = count;
  }else{
    validateResponse['error'] = false;
    validateResponse['error_count'] = count;
  }
  return validateResponse;
}

function validateInputFieldOnBlur(key, value){
  var validateResponse = {};
  validateResponse['error'] = false;
  if(!value){
    validateResponse[key] = getErrorMessage(key);
    validateResponse['error'] = true;
  }else{
    var res = validate(value, key);
    if(res != "valid"){
      validateResponse[key] = res;
    }
  }
  return validateResponse;
}


function validate(value, key){
  var filter = /^\-{0,1}(?:[0-9]+){0,1}(?:\.[0-9]+){0,1}$/i;
  var regex = RegExp(filter);
  if(regex.test(value)){
    return "valid";
  }else{
    return getErrorMessage(key);
  }
}


function getErrorMessage(key){
  var message = "";
  switch(key){
    case "net_weight":
      message = "Enter valid Net Weight";      
      break ;
    case "upc":
      message = "Enter valid UPC";
      break;
    case "dia":
      message = "Enter valid DIA";
     break;
    case "thickness":
      message = "Enter valid Thickness";
      break;
    case "EOEdia":
      message = "Enter valid EOE DIA";
      break;
    case "plasticdia":
      message = "Enter valid Plastic DIA";
      break;
    case "corrigated_box_type":
      message = "Enter valid Corrigated Box Type";
      break;
    case "paper_gsm":
      message = "Enter valid Paper Gsm";
      break;
    case "moisture":
      message = "Enter valid Moisture";
      break;
    case "box_compression_strength":
      message = "Enter valid Box Compression Strength";
      break;
    case "corrigated_length":
      message = "Enter valid Corrigated Length";
      break;
    case "flute":
      message = "Enter valid Flute";
      break;
    case "corrigated_width":
      message = "Enter valid Corrigated Width";
      break;
    case "printed_carton":
      message = "Enter valid Printed Carton";
      break;
    case "corrigated_height":
      message = "Enter valid Corrigated Height";
      break;
    case "ply":
      message = "Enter valid Ply";
      break;
    case "type":
      message = "Enter valid Type";
      break  
    case "container_size":
      message = "Enter valid Container Size";
      break;
    case "pallet_type":
      message = "Enter valid Pallet Type";
      break;
    case "load_total_weight":
      message = "Enter valid Load Total Weight";
      break;
    case "load_no_of_boxes":
      message = "Enter valid Load No of Boxes";
      break;
  }
  return message;
}

export {
    loginSchema,
    emailSchema,
    verificationSchema,
    createUserSchema,
    changePasswordSchema,
    validateInputFields,
    validateInputFieldOnBlur
};